import { render } from "./DetailedAccounts.vue?vue&type=template&id=df64253e&scoped=true"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"

import "./DetailedAccounts.vue?vue&type=style&index=0&id=df64253e&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df64253e"]])

export default __exports__